import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {
  AlertModule,
  InputFieldModule,
  InputSelectAddonModule,
  InputSelectModule,
  InputSubmitModule,
  ItineraryResumeModule,
  ModalModule,
  TitleModule
} from 'src/app/components';
import { BookingCredentialsModule } from 'src/app/components/booking-credentials/booking-credentials.module';
import { ReRouteSplitStepComponent } from './re-route-split-step.component';

@NgModule({
  declarations: [ReRouteSplitStepComponent],
  imports: [
    CommonModule,
    InputSelectModule,
    InputSubmitModule,
    InputFieldModule,
    ReactiveFormsModule,
    TranslateModule,
    ModalModule,
    AlertModule,
    InputSelectAddonModule,
    TitleModule,
    BookingCredentialsModule,
    ItineraryResumeModule
  ],
  exports: [ReRouteSplitStepComponent]
})
export class ReRouteSplitStepModule {}
